import {

  LayoutGrid,
} from "lucide-react";

type Submenu = {
  href: string;
  label: string;
  active: boolean;
};

type Menu = {
  href: string;
  label: string;
  active: boolean;
  icon: any;
  submenus: Submenu[];
};



export function getMenuList(pathname: string): Menu[] {
  return [

    {
      href: "/dashboard",
      label: "Recharges",
      active: pathname.includes("/dashboard"),
      icon: LayoutGrid,
      submenus: []
    },

    {
      href: "/parrainage",
      label: "Parrainage",
      active: pathname.includes("/parrainage"),
      icon: LayoutGrid,
      submenus: []
    },
    // Ajoute d'autres menus ici si nécessaire
  ];
}
